/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import Wrapper from './Wrapper';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  unsubscribe,
} from '../actions';


class Unsubscribe extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  state = {};

  render() {
    return (
      <Wrapper className="Unsubscribe" title="Unsubscribe">
        You won't receive emails like that anymore
      </Wrapper>
    );
  }

  componentDidMount() {
    this.props.unsubscribe({ key: this.props.params.key })
      .then(resp => {
        console.log('unsub resp', resp);
      });
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    unsubscribe,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Unsubscribe);



/** WEBPACK FOOTER **
 ** ./src/components/Unsubscribe.js
 **/